import { render, staticRenderFns } from "./FrontpageAreas.vue?vue&type=template&id=1f905576&"
import script from "./FrontpageAreas.vue?vue&type=script&lang=js&"
export * from "./FrontpageAreas.vue?vue&type=script&lang=js&"
import style0 from "./FrontpageAreas.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports